import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

const i4pLightTheme = {
  dark: false,
  headerLogo: '/dark-logo.png',
  colors: {
    primary: '#FDB714',
    secondary: '#FFF4DC',
    textColor: '#000000',
    primaryButtonTextColor: '#FFFFFF',
    normalButtonBackground: '#f5f5f5',
    normalButtonTextColor: '#4A4A4A',
    success: {
      base: '#64c636',
      lighten1: '#E7FFD9',
      darken1: '#36C658'
    },
    error: '#FF7C7C',
    headerBackground: '#272727',
    headerTextColor: '#FFFFFF',
    cardBackground: '#FFFFFF',
    cardText: '#9e9e9e',
    datatableBackground: '#FFFFFF',
    datatableTextColor: '#4A4A4A',
    datatableHighlightBackground: '#eeeeee',
    accent: '#82b1ff',
    grey: '#9e9e9e',
    statusEnabled: '#e7ffd9',
    statusEnabledTextColor: '#64c636',
    statusInactive: '#d1e8ff',
    statusInactiveTextColor: '#007afe',
    navbarBackground: '#FFFFFF',
    navbarTextColor: '#000000',
    navbarActiveTextColor: '#FDB714',
    navbarIconBackground: '#FFF4DC',
    navbarActiveIcon: '#FFFFFF',
    navbarActiveIconBackground: '#FDB714',
    background: '#F3F3F3',
    scrollbarThumbBackgroundColor: '#d6dee1',
    scrollbarThumbHoverBackgroundColor: '#a8bbbf'
  }
}
// theme.global.name.value =
const thirdpartyRedLightTheme = {
  name: 'thirdpartyRedLightTheme',
  dark: false,
  headerLogo: '/vuelogo.png',
  colors: {
    primary: '#CD5C5C',
    secondary: '#FFF4DC',
    textColor: '#FFFFFF',
    primaryButtonTextColor: '#FFFFFF',
    normalButtonBackground: '#6a5acd',
    normalButtonTextColor: '#FFFFFF',
    success: {
      base: '#64C636',
      lighten1: '#E7FFD9',
      darken1: '#36C658'
    },
    error: '#007AFE',
    headerBackground: '#6a5acd',
    headerTextColor: '#36c658',
    cardBackground: '#FF7C7C',
    cardText: '#9e9e9e',
    datatableBackground: '#FF7C7C',
    datatableTextColor: '#FFFFFF',
    datatableHighlightBackground: '#FF00FF',
    accent: '#FFF4DC',
    grey: '#FFF4DC',
    statusEnabled: '#e7ffd9',
    statusEnabledTextColor: '#36c658',
    statusInactive: '#d1e8ff',
    statusInactiveTextColor: '#007afe',
    navbarBackground: '#F08080',
    navbarTextColor: '#FFFFFF',
    navbarActiveTextColor: '#9965f4',
    navbarIconBackground: '#ee82ee',
    navbarActiveIcon: '#FFFFFF',
    navbarActiveIconBackground: '#DE3163',
    background: '#DE3163',
    scrollbarThumbBackgroundColor: '#d6dee1',
    scrollbarThumbHoverBackgroundColor: '#a8bbbf'

  }
}

const thirdpartyDarkTheme = {
  name: 'thirdpartyDarkTheme',
  dark: true,
  headerLogo: '/vuelogo.png',
  colors: {
    primary: '#9965f4',
    secondary: '#FFF4DC',
    textColor: '#FFFFFF',
    primaryButtonTextColor: '#FFFFFF',
    normalButtonBackground: '#6a5acd',
    normalButtonTextColor: '#FFFFFF',
    success: {
      base: '#64C636',
      lighten1: '#E7FFD9',
      darken1: '#36C658'
    },
    error: '#FF7C7C',
    headerBackground: '#7b7b7b',
    headerTextColor: '#FFFFFF',
    cardBackground: '#9d9d9d',
    cardText: '#000000',
    datatableBackground: '#9d9d9d',
    datatableTextColor: '#FFFFFF',
    datatableHighlightBackground: '#434343',
    accent: '#FFF4DC',
    grey: '#f5f5f5',
    statusEnabled: '#e7ffd9',
    statusEnabledTextColor: '#36c658',
    statusInactive: '#d1e8ff',
    statusInactiveTextColor: '#007afe',
    navbarBackground: '#262626',
    navbarTextColor: '#FFFFFF',
    navbarActiveTextColor: '#9965f4',
    navbarIconBackground: '#9d9d9d',
    navbarActiveIcon: '#FFFFFF',
    navbarActiveIconBackground: '#AB47BC',
    background: '#121212',
    scrollbarThumbBackgroundColor: '#9d9d9d',
    scrollbarThumbHoverBackgroundColor: '#9965f4'

  }
}

export default new Vuetify({
  theme: {
    defaultTheme: 'i4pLightTheme',
    themes: {
      light: i4pLightTheme.colors, i4pLightTheme, thirdpartyRedLightTheme, thirdpartyDarkTheme
    },

    options: {
      customProperties: true
    }

  },
  global: {
    ripples: false // this disable naviagiton menu buggy row selection glitch on click
  }

})
